<template>
  <div class="x-tablelist-view" data-automation="keyList">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @changeTime="changeTime"
      @change="change"
      @search="seach"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        :emptyText="$t('HT.nodata')"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'date',
          daterange: true,
          time: true,
          event: 'changeTime'
        },
        {
          type: 'input',
          key: 'imei',
          placeholder: '请输入imei进行搜索'
        }
      ],
      columns: [
        // 表头数据
        {
          label: '子应用',
          prop: 'sub_application',
          tooltip: true
        },
        {
          label: '服务器',
          prop: 'logger_host',
          tooltip: true
        },
        {
          label: '日志内容',
          prop: 'message',
          tooltip: true
        }
      ],
      filter: {
        // 查询参数
        imei: '',
        startTime: '',
        endTime: '',
        page: 1,
        size: 10
      },
      apiList: [], // api 列表
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },

  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getHeartList(params) {
      this.$api.log.getHeartList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 搜索
     */
    seach() {
      if (this.filter.startTime == '' || this.filter.startTime == undefined) {
        this.$uxModal.hide();
        this.$uxMessage.warning('请选择时间');
        return;
      }
      if (this.filter.imei == '') {
        this.$uxModal.hide();
        this.$uxMessage.warning('请输入imei号');
        return;
      } else {
        this.getHeartList(this.filter);
        this.filter.page = 1;
      }
    },

    change() {
      this.filter.page = 1;
    },

    /**
     * 时间筛选
     * @param {Array} array 起始时间数组
     */
    changeTime(array) {
      this.filter.page = 1;
      this.filter.startTime = array[0];
      this.filter.endTime = array[1];
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getHeartList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getHeartList(this.filter);
    }
  }
};
</script>
